import React from 'react'
import StopReasonCodeGroups from '../features/stopReasonCodeGroups'

export default function StopReasonCodeGroupsPage() {
  return (
    <StopReasonCodeGroups />
  )
}
